/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AnalyticsService } from '../@core/utils/analytics.service';
import { SeoService } from '../@core/utils/seo.service';
import { NbSpinnerService, NbGlobalPhysicalPosition, NbGlobalLogicalPosition, NbGlobalPosition, NbComponentStatus, NbToastrService } from '@nebular/theme';
import { FormGroup, ReactiveFormsModule, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { ToasterConfig } from 'angular2-toaster';
import { EpicService } from '../pages/event/event.service';
import { IFSEntrySub, FSEntrySub } from '../pages/event/event.model';
import { ViewportScroller } from '@angular/common';


@Component({
  selector: 'ngx-app-cover-page',
  templateUrl: './app-cover-page.component.html',
  styleUrls: ['./style.css']
})
export class AppCoverPageComponent implements OnInit {

  subForm: FormGroup;
  config: ToasterConfig;
  destroyByClick = true;
  duration = 9000;
  hasIcon = true;
  position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
  preventDuplicates = true;

  types: NbComponentStatus[] = [
    'primary',
    'success',
    'info',
    'warning',
    'danger',
  ];
  positions: string[] = [
    NbGlobalPhysicalPosition.TOP_RIGHT,
    NbGlobalPhysicalPosition.TOP_LEFT,
    NbGlobalPhysicalPosition.BOTTOM_LEFT,
    NbGlobalPhysicalPosition.BOTTOM_RIGHT,
    NbGlobalLogicalPosition.TOP_END,
    NbGlobalLogicalPosition.TOP_START,
    NbGlobalLogicalPosition.BOTTOM_END,
    NbGlobalLogicalPosition.BOTTOM_START,
  ];

  get city(): AbstractControl { return this.subForm.get('city'); }
  get phoneNumber(): AbstractControl { return this.subForm.get('phoneNumber'); }
  get email(): AbstractControl { return this.subForm.get('email'); }
  get name(): AbstractControl { return this.subForm.get('name'); }
  get postcode(): AbstractControl { return this.subForm.get('postcode'); }
  get message(): AbstractControl { return this.subForm.get('message'); }

  constructor(private viewportScroller: ViewportScroller, private fb: FormBuilder, private toastrService: NbToastrService, private epicService: EpicService, private analytics: AnalyticsService, private seoService: SeoService, private spinner$: NbSpinnerService) {
    this.subForm = this.fb.group({
      city: [''],
      phoneNumber: ['', Validators.required],
      email: ['', Validators.required],
      name: ['', Validators.required],
      message: ['', Validators.required],
      postcode: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.spinner$.load();
  }

  makeToast(status: NbComponentStatus, title: string, content: string) {
    this.showToast(status, title, content);
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: this.destroyByClick,
      duration: this.duration,
      hasIcon: this.hasIcon,
      position: this.position,
      preventDuplicates: this.preventDuplicates,
    };
    const titleContent = title ? ` ${title}` : '';

    this.toastrService.show(
      body,
      `${titleContent}`,
      config);
  }

  onSubSubmit() {
    this.subForm.markAsPristine();
    let sub: IFSEntrySub = new FSEntrySub(this.name.value, this.email.value, this.message.value, this.city.value, this.postcode.value, this.phoneNumber.value, (new Date()).toISOString());
    this.epicService.postSub(sub).then(_ => {
      window.alert("Inscription envoyée !!!!!!")
      this.subForm.reset();
    }, msg => { window.alert("Erreur lors de l'envoi") })
  }

  public onClick(elementId: string): void {
    console.log(elementId);
    this.viewportScroller.scrollToAnchor(elementId);
  }

  isNavbarCollapsed: boolean = true;

  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  @ViewChild('navbarElement', { static: true })
  navbarElementRef!: ElementRef;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.navbarElementRef && this.navbarElementRef.nativeElement.contains(event.target)) {
      return;
    }
    this.isNavbarCollapsed = true;
  }
}
